import { render, staticRenderFns } from "./MobilePreviewer.vue?vue&type=template&id=5826de5b&scoped=true&"
import script from "./MobilePreviewer.vue?vue&type=script&lang=js&"
export * from "./MobilePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreviewer.vue?vue&type=style&index=0&id=5826de5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826de5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
